// extracted by mini-css-extract-plugin
export default {"container":"popover_container__V3TnM"};